export var getActiveFilters = function (criteria, filters) {
    return Object.keys(filters)
        .map(function (k) { return (filters[k].hasValue(criteria) ? k : undefined); })
        .filter(Boolean);
};
//# sourceMappingURL=get-active-filters.js.map